import { Component } from "@angular/core";
import { QuickscanFilterComponent } from "../../shared/quickscan-filter/quickscan-filter.component";
import { QuickscanTableComponent } from "../../shared/quickscan-table/quickscan-table.component";

@Component({
  selector: "app-quickscans",
  imports: [QuickscanFilterComponent, QuickscanTableComponent],
  templateUrl: "./quickscans.component.html",
  styleUrls: ["./quickscans.component.less"],
})
export class QuickscansComponent {}
